import * as styles from './PostLayoutSizes.module.scss';

function parseStyleValue(value: string, defaultValue: number): number {
  const result = parseInt(value, 10);
  return Number.isNaN(result) ? defaultValue : result;
}

export const TOC_MIN_WIDTH = parseStyleValue(styles.tocMinWidth, 188);
export const TOC_COLLAPSED_WIDTH = parseStyleValue(
  styles.tocCollapsedWidth,
  28,
);
export const MAGNETIC_WALL_MIN_WIDTH = parseStyleValue(
  styles.magneticWallMinWidth,
  246,
);
const MAGNETIC_WALL_MAX_WIDTH = parseStyleValue(
  styles.magneticWallMaxWidth,
  290,
);
export const MAGNETIC_WALL_WIDE_WIDTH = parseStyleValue(
  styles.magneticWallWideWidth,
  422,
);
export const MAGNETIC_WALL_COLLAPSED_WIDTH = parseStyleValue(
  styles.magneticWallCollapsedWidth,
  86,
);
export const SIDEBAR_WIDTH = parseStyleValue(styles.sidebarWidth, 250);
export const INNER_RIGHT_CONTENT_PADDING = parseStyleValue(
  styles.innerRightContentPadding,
  32,
);
export const STATIC_AREAS_WIDTH = parseStyleValue(
  styles.staticAreasWidth,
  660 + 62 + INNER_RIGHT_CONTENT_PADDING + 2 * 24,
);

export const POST_SIDEBAR_SHIFT_BREAKPOINT =
  STATIC_AREAS_WIDTH +
  SIDEBAR_WIDTH +
  MAGNETIC_WALL_COLLAPSED_WIDTH +
  TOC_COLLAPSED_WIDTH;

export const PRIORITY_LIST_MAX_WIDTH =
  STATIC_AREAS_WIDTH + MAGNETIC_WALL_MIN_WIDTH + TOC_MIN_WIDTH + SIDEBAR_WIDTH;

// Below this screen size, the magnetic wall cannot be expanded
export const POST_MAGNETIC_WALL_EXPAND_RANGE = [
  STATIC_AREAS_WIDTH + TOC_MIN_WIDTH + MAGNETIC_WALL_MAX_WIDTH, // 1280px
  Infinity,
] as const;

export const PUBLIC_DOCUMENTATION_MAGNETIC_WALL_EXPAND_RANGE = [
  STATIC_AREAS_WIDTH + TOC_COLLAPSED_WIDTH + MAGNETIC_WALL_MAX_WIDTH, // 1120px
  Infinity,
] as const;
